import store from '../redux/store';
import axios from 'axios';
import tools from './tools';

async function preCheck(username, cancelTokenParam) { 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();   
  var url = `${tools.getBaseHost()}/auth/pre-check/`;
  const request = axios.post(url, {email: username}, {
    headers: { Timezone: tools.getTimezone() },
    cancelToken: cancelToken.token 
  });
  return request;
}

async function login(username, password, cancelTokenParam) { 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();   
  var url = `${tools.getBaseHost()}/auth/jwt/create/`;
  const request = axios.post(url, {email: username, password}, {
    headers: { Timezone: tools.getTimezone() },
    cancelToken: cancelToken.token 
  });
  return request;
}

async function forgotPassword(email, cancelTokenParam) { 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();   
  var url = `${tools.getBaseHost()}/account/reset_password/`;
  const request = axios.post(url, {email: email}, {
    headers: { Timezone: tools.getTimezone() },
    cancelToken: cancelToken.token 
  });
  return request;
}

async function resetPassword(new_password, re_new_password, uid, token, cancelTokenParam) { 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();   
  var url = `${tools.getBaseHost()}/account/reset_password_confirm/`;
  const request = axios.post(url, {new_password, re_new_password, uid, token}, {
    headers: { Timezone: tools.getTimezone() },
    cancelToken: cancelToken.token 
  });
  return request;
}

async function activation(new_password, re_new_password, uid, token, cancelTokenParam) { 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();   
  var url = `${tools.getBaseHost()}/account/activation/`;
  const request = axios.post(url, {new_password, re_new_password, uid, token}, {
    headers: { Timezone: tools.getTimezone() },
    cancelToken: cancelToken.token 
  });
  return request;
}

function logout() {
  localStorage.clear();
}

function isAuthenticated(){
  const user = store.getState().user;
  const userIsAuthenticaded = user && user.data ? true : false;
  return userIsAuthenticaded;
}

export default {
  preCheck,
  login,
  logout,
  isAuthenticated,
  forgotPassword,
  resetPassword,
  activation
}